declare namespace $ {

	type __rise_resize_1 = $mol_type_enforce<
		Parameters< $rise_resize['drag_pointerdown'] >[0]
		,
		Parameters< ReturnType< $rise_resize['Drag_view'] >['pointerdown'] >[0]
	>
	type $rise_drag_view__minimal_height_rise_resize_2 = $mol_type_enforce<
		number
		,
		ReturnType< $rise_drag_view['minimal_height'] >
	>
	type $rise_drag_view__sub_rise_resize_3 = $mol_type_enforce<
		ReturnType< $rise_resize['drag_body'] >
		,
		ReturnType< $rise_drag_view['sub'] >
	>
	type $rise_drag_view__x_rise_resize_4 = $mol_type_enforce<
		ReturnType< $rise_resize['x'] >
		,
		ReturnType< $rise_drag_view['x'] >
	>
	type $rise_drag_view__y_rise_resize_5 = $mol_type_enforce<
		ReturnType< $rise_resize['y'] >
		,
		ReturnType< $rise_drag_view['y'] >
	>
	type $rise_drag_view__on_drag_start_rise_resize_6 = $mol_type_enforce<
		ReturnType< $rise_resize['on_drag_start'] >
		,
		ReturnType< $rise_drag_view['on_drag_start'] >
	>
	type $rise_drag_view__on_drag_rise_resize_7 = $mol_type_enforce<
		ReturnType< $rise_resize['on_drag'] >
		,
		ReturnType< $rise_drag_view['on_drag'] >
	>
	type $rise_drag_view__on_drag_end_rise_resize_8 = $mol_type_enforce<
		ReturnType< $rise_resize['on_drag_end'] >
		,
		ReturnType< $rise_drag_view['on_drag_end'] >
	>
	type $rise_drag_view__drags_synced_rise_resize_9 = $mol_type_enforce<
		ReturnType< $rise_resize['drags_synced'] >
		,
		ReturnType< $rise_drag_view['drags_synced'] >
	>
	type $rise_drag_view__repos_x_rise_resize_10 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_drag_view['repos_x'] >
	>
	type $rise_drag_view__repos_y_rise_resize_11 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_drag_view['repos_y'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_12 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_13 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_14 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_15 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_16 = $mol_type_enforce<
		ReturnType< $rise_resize['top_edge_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_17 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_18 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_19 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_20 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__x_rise_resize_21 = $mol_type_enforce<
		ReturnType< $rise_resize['left_edge_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_22 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_23 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_24 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_25 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_26 = $mol_type_enforce<
		ReturnType< $rise_resize['bottom_edge_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_27 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_28 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_29 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_30 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__x_rise_resize_31 = $mol_type_enforce<
		ReturnType< $rise_resize['right_edge_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_32 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_33 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_34 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_35 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_36 = $mol_type_enforce<
		ReturnType< $rise_resize['top_edge_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__x_rise_resize_37 = $mol_type_enforce<
		ReturnType< $rise_resize['left_edge_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_38 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_39 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_40 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_41 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_42 = $mol_type_enforce<
		ReturnType< $rise_resize['top_edge_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__x_rise_resize_43 = $mol_type_enforce<
		ReturnType< $rise_resize['right_edge_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_44 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_45 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_46 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_47 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_48 = $mol_type_enforce<
		ReturnType< $rise_resize['bottom_edge_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__x_rise_resize_49 = $mol_type_enforce<
		ReturnType< $rise_resize['left_edge_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	type $rise_resize_edge__repos_x_rise_resize_50 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_x'] >
		,
		ReturnType< $rise_resize_edge['repos_x'] >
	>
	type $rise_resize_edge__repos_y_rise_resize_51 = $mol_type_enforce<
		ReturnType< $rise_resize['repos_y'] >
		,
		ReturnType< $rise_resize_edge['repos_y'] >
	>
	type $rise_resize_edge__on_drag_start_rise_resize_52 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_start'] >
		,
		ReturnType< $rise_resize_edge['on_drag_start'] >
	>
	type $rise_resize_edge__on_drag_end_rise_resize_53 = $mol_type_enforce<
		ReturnType< $rise_resize['resize_end'] >
		,
		ReturnType< $rise_resize_edge['on_drag_end'] >
	>
	type $rise_resize_edge__y_rise_resize_54 = $mol_type_enforce<
		ReturnType< $rise_resize['bottom_edge_y'] >
		,
		ReturnType< $rise_resize_edge['y'] >
	>
	type $rise_resize_edge__x_rise_resize_55 = $mol_type_enforce<
		ReturnType< $rise_resize['right_edge_x'] >
		,
		ReturnType< $rise_resize_edge['x'] >
	>
	export class $rise_resize extends $mol_view {
		drag_body( ): readonly(any)[]
		x( next?: number ): number
		y( next?: number ): number
		on_drag_start( next?: any ): any
		on_drag( next?: any ): any
		on_drag_end( next?: any ): any
		dragged( ): ReturnType< ReturnType< $rise_resize['Drag_view'] >['dragged'] >
		drags_synced( ): readonly($rise_drag)[]
		Drag( ): ReturnType< ReturnType< $rise_resize['Drag_view'] >['Drag'] >
		repos_x( id: any): number
		repos_y( id: any): number
		drag_pointerdown( next?: ReturnType< ReturnType< $rise_resize['Drag_view'] >['pointerdown'] > ): ReturnType< ReturnType< $rise_resize['Drag_view'] >['pointerdown'] >
		Drag_view( ): $rise_drag_view
		controls( ): readonly(any)[]
		resize_start( next?: any ): any
		resize_end( next?: any ): any
		top_edge_y( next?: number ): number
		Top_edge( ): $rise_resize_edge
		left_edge_x( next?: number ): number
		Left_edge( ): $rise_resize_edge
		bottom_edge_y( next?: number ): number
		Bottom_edge( ): $rise_resize_edge
		right_edge_x( next?: number ): number
		Right_edge( ): $rise_resize_edge
		Top_left_edge( ): $rise_resize_edge
		Top_right_edge( ): $rise_resize_edge
		Bottom_left_edge( ): $rise_resize_edge
		Bottom_right_edge( ): $rise_resize_edge
		edges( ): readonly(any)[]
		top_px( ): string
		left_px( ): string
		height_px( ): string
		width_px( ): string
		sub( ): readonly(any)[]
		resizing( next?: boolean ): boolean
		transforming( ): boolean
		height_min( ): number
		width_min( ): number
		height( next?: number ): number
		width( next?: number ): number
		top( next?: number ): number
		left( next?: number ): number
		stick_threshold( ): number
		x_stick( next?: number ): number
		y_stick( next?: number ): number
		bottom_edge_y_stick( next?: ReturnType< $rise_resize['height_min'] > ): ReturnType< $rise_resize['height_min'] >
		right_edge_x_stick( next?: ReturnType< $rise_resize['width_min'] > ): ReturnType< $rise_resize['width_min'] >
		top_edge_y_stick( next?: number ): number
		left_edge_x_stick( next?: number ): number
		stickable( next?: boolean ): boolean
		sticks_y( ): readonly(number)[]
		sticks_x( ): readonly(number)[]
		auto( ): readonly(any)[]
		style( ): ({ 
			'top': ReturnType< $rise_resize['top_px'] >,
			'left': ReturnType< $rise_resize['left_px'] >,
			'height': ReturnType< $rise_resize['height_px'] >,
			'width': ReturnType< $rise_resize['width_px'] >,
		})  & ReturnType< $mol_view['style'] >
	}
	
	export class $rise_resize_edge extends $rise_drag_view {
	}
	
}

//# sourceMappingURL=resize.view.tree.d.ts.map